export default {
  en() {
    return {
      accommodation: 'Accommodation',
      add: 'ADD',
      addToCart: 'ADD TO CART',
      addToBasket: 'Add To Basket',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'Continue',
      discount: 'Discount',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}.',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}.',
      error: 'There was an error with your submission',
      noAccommodations: 'No Accommodations',
      numberOfPeople: '# of People',
      package: 'Package',
      packageInCart:'{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Package Pricing',
      packagePricingSglmg: 'Your Package Pricing',
      packageTotal: 'Package Total',
      packageQty: 'Package Qty',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Processing Fee',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Ready to Book? Call {phoneLink}</span> or complete the form for pricing and package options.',
      requiredField: 'This field is required',
      roomQty: 'Room Qty',
      roomType: 'Room Type',
      soldOut: 'Sold Out',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(Taken in Cart)',
      yourTicket: 'Your Ticket',
      viewCart: 'view your cart»'
    }
  },
  ar() {
    return {
      accommodation: 'مكان الإقامة',
      add: 'أضف',
      addToCart: 'أضِفْ إلى سلّة/عربة التسوّق',
      addToBasket: 'Add To Basket',
      buyNow: 'Buy Now',
      chooseYourPackage: 'اقبل', // https://qe360.quintevents.com/admin/phrases/20122',
      continue: 'واصلْ',
      discount: 'تخفيض',
      dueDateTextTwo: 'سيتمّ تقسيم الدفعات المُستحقّة بالتساوي عند التوقيع وفي {date}',
      dueDateTextMultiple: 'سيتمّ تقسيط الدفوعات المُستحقّة بالتساوي عند التوقيع، في {datesList}',
      error: 'كان هناك خطأ في تقديم طلبك',
      noAccommodations: 'لا توجد أماكن إقامة',
      numberOfPeople: '# من الناس',
      package: 'باقة',
      packageInCart: '.لقد أُضيفت {yourPackage} إلى سلّة تسوّقك. لإدخال التغييرات وتسجيل الخروج',
      packagePricing: 'سعر الباقة',
      packagePricingSglmg: 'Your Package Pricing',
      packageTotal: 'Package Total',
      packageQty: 'كميّة الباقات',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'كلفة معالجة المسألة',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'حدّد كمّيّتك',
      readyToCall: '<span>هل أنت مُستعدّ للحجز؟ اتّصل بـ {phoneLink}</span> أو املأ الاستمارة لاختيار الباقات والاطّلاع على أسعارها',
      requiredField: 'بيانات هذه الخانة مطلوبة',
      roomQty: 'عدد الغرف',
      roomType: 'نوع الغرفة',
      soldOut: 'نفاذ الكميّة/تمّ بيع كلّ المنتجات',
      subtotal: ':المجموع الفرعيّ',
      takenInCart: '(تمّ إضافته إلى سلّة التسوّق)',
      total: 'Total:',
      yourTicket: 'تذكرتُك',
      viewCart: 'اطّلع على مُحتوى سلّة تسوّقك',
    }
  },
  caES() {
    return {
      accommodation: 'Accommodation',
      add: 'AFEGIR',
      addToCart: 'AFEGIR A LA CISTELLA',
      addToBasket: 'Add To Basket',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'Continua',
      discount: 'Descompte',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}',
      error: 'S’ha produït un error amb el teu enviament',
      noAccommodations: 'Sense allotjament',
      numberOfPeople: '# of People',
      package: 'Paquet',
      packageInCart: '{yourPackage} és a la teva cistella. Per editar o finalitzar la compra,',
      packagePricing: 'Preus del paquet',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Quant. de paquets',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Despeses de gestió',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Preparat per reservar? Truca’ns al {phoneLink}</span> o emplena el formulari per consultar preus i opcions de paquets.',
      requiredField: 'Aquest camp és obligatori',
      roomQty: 'Núm. d’habitacions',
      roomType: 'Room Type',
      soldOut: 'Exhaurit',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(Reservat en la Cistella)',
      yourTicket: 'La teva entrada',
      viewCart: 'consulta la teva cistella»',
    }
  },
  de() {
    return {
      accommodation: 'Unterkunft',
      add: 'HINZUFÜGEN',
      addToCart: 'ZUM WARENKORB HINZUFÜGEN',
      addToBasket: 'In den Warenkorb',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Wählen Sie Ihr Paket & die Anzahl',
      continue: 'Fortfahren',
      discount: 'Ermäßigung',
      dueDateTextTwo: 'Die Zahlungen werden gleichmäßig aufgeteilt und sind bei Unterzeichnung & am {date} fällig.',
      dueDateTextMultiple: 'Die Zahlungen werden gleichmäßig aufgeteilt und sind bei Vertragsabschluss fällig, am {datesList}',
      error: 'Bei Ihrer Übermittlung ist ein Fehler aufgetreten',
      noAccommodations: 'Keine Unterkünfte',
      numberOfPeople: '# Personen',
      package: 'Paket',
      packageInCart: '{yourPackage} befindet sich in Ihrem Warenkorb. Um es zu bearbeiten oder zur Kasse zu gehen',
      packagePricing: 'Paketpreise',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Anzahl Pakete',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Bearbeitungsgebühr',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Anzahl auswählen',
      readyToCall: '<span>Bereit, zu buchen? Rufen Sie uns unter {phoneLink}</span> an oder füllen Sie das Formular aus, um mehr über Preise und Paketoptionen zu erfahren.',
      requiredField: 'Dies ist ein Pflichtfeld',
      roomQty: 'Anzahl Zimmer',
      roomType: 'Zimmertyp',
      soldOut: 'Ausverkauft',
      subtotal: 'Zwischentotal:',
      takenInCart: '(In den Warenkorb gelegt)',
      total: 'Total:',
      yourTicket: 'Ihr Ticket',
      viewCart: 'Ihren Warenkorb anzeigen»',
    }
  },
  enGB() {
    return {
      accommodation: 'Accommodation',
      add: 'ADD',
      addToCart: 'ADD TO CART',
      addToBasket: 'Add To Basket',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'Continue',
      discount: 'Discount',
      dueDateTextTwo: 'Payments will be split equally and due at signing & on {date}',
      dueDateTextMultiple: 'Payments will be split equally and due at signing, on {datesList}',
      error: 'There was an error with your submission',
      noAccommodations: 'No Accommodations',
      numberOfPeople: '# of People',
      package: 'Package',
      packageInCart: '{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'Package Pricing',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Package Qty',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Processing Fee',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Ready to Book? Call {phoneLink}</span> or complete the form for pricing and package options.',
      requiredField: 'This field is required',
      roomQty: 'Room Qty',
      roomType: 'Room Type',
      soldOut: 'Sold Out',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(Taken in Cart)',
      yourTicket: 'Your Ticket',
      viewCart: 'view your cart»',
    }
  },
  esMX() {
    return {
      accommodation: 'Alojamiento',
      add: 'Añadir',
      addToCart: 'Añadir al Carrito',
      addToBasket: 'Añadir a la Canasta',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Elija su paquete y cantidad',
      continue: 'Continuar',
      discount: 'Descuento',
      dueDateTextTwo: 'Los pagos serán divididos en dos partes iguales y son pagaderos al firmar en {date}',
      dueDateTextMultiple: 'Los pagos serán divididos de manera equitativa y serán pagaderos al momento de la firma en {datesList}',
      error: 'Hubo un error con el envío de su información',
      noAccommodations: 'Sin Alojamiento',
      numberOfPeople: '# de Personas',
      package: 'Paquete',
      packageInCart: '{yourPackage} está en su carrito. Para editarlo o proceder al pago,',
      packagePricing: 'Precio de Paquete',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Cantidad de Paquetes',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Tarifa de Procesamiento',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Elija Su Cantidad',
      readyToCall: '<span>¿Listo para reservar? Llame al {phoneLink}</span> o complete el formulario para conocer los precios y las opciones de los paquetes.',
      requiredField: 'Este campo es requerido',
      roomQty: 'Cantidad de Habitaciones',
      roomType: 'Tipo de Habitación',
      soldOut: 'Vendido',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(En el carrito)',
      yourTicket: 'Su boleto',
      viewCart: 'ver su carrito»',
    }
  },
  es() {
    return {
      accommodation: 'Alojamiento',
      add: 'AÑADIR',
      addToCart: 'AÑADIR AL CARRITO',
      addToBasket: 'Añadir a la Canasta',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Elige Tu Paquete y Cantidad',
      continue: 'Continuar',
      discount: 'Descuento',
      dueDateTextTwo: 'Los pagos se dividirán en partes iguales y serán abonados a la firma y el {date}',
      dueDateTextMultiple: 'Los pagos se dividirán en partes iguales y serán abonados a la firma, el {datesList}',
      error: 'Ha habido un error en tu envío',
      noAccommodations: 'Sin Alojamientos',
      numberOfPeople: '# de Personas',
      package: 'Paquete',
      packageInCart: '{yourPackage} está en tu carrito. Para editar o verificar,',
      packagePricing: 'Precio del Paquete',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Número de Paquetes',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Tasa de Tramitación',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Elige Tu Cantidad',
      readyToCall: '<span>¿Listo para Reservar? Llama al {phoneLink}</span> o completa el formulario para conocer los precios y las opciones de los paquetes.',
      requiredField: 'Este apartado es obligatorio',
      roomQty: 'Número de Habitaciones',
      roomType: 'Tipo de Habitación',
      soldOut: 'Agotado',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(Cogido en el Carrito)',
      yourTicket: 'Tu Entrada',
      viewCart: 'ver tu carrito»',
    }
  },
  fr() {
    return {
      accommodation: 'Logement',
      add: 'AJOUTER',
      addToCart: 'AJOUTER AU PANIER',
      addToBasket: 'Ajouter Au Panier',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Choisissez votre forfait et sa quantité',
      continue: 'Continuer',
      discount: 'Remise',
      dueDateTextTwo: 'Le paiement sera divisé en versements égaux dus à la signature du contrat et à la date du {date}.',
      dueDateTextMultiple: 'Le paiement sera divisé en versements égaux dus à la signature du contrat, et aux dates suivantes : {datesList}',
      error: 'Une erreur est survenue lors votre inscription',
      noAccommodations: 'Pas d\'hébergement',
      numberOfPeople: 'Nombre de personnes',
      package: 'Forfait',
      packageInCart: '{yourPackage} est dans votre panier. Pour le modifier ou payer,',
      packagePricing: 'Tarifs des forfaits',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Nombre de forfaits',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Frais de traitement',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Choisissez votre quantité',
      readyToCall: '<span>Prêt à réserver ? Appelez le {phoneLink}</span> ou remplissez le formulaire pour des options de tarification et de forfait.',
      requiredField: 'Ce champ est obligatoire',
      roomQty: 'Nombre de chambres',
      roomType: 'Type de chambre',
      soldOut: 'Épuisé',
      subtotal: 'Sous-total :',
      takenInCart: '(Ajouté au panier)',
      total: 'Total:',
      yourTicket: 'Votre billet',
      viewCart: 'voir votre panier»',
    }
  },
  it() {
    return {
      accommodation: 'Sistemazione',
      add: 'AGGIUNGI',
      addToCart: 'AGGIUNGI AL CARRELLO',
      addToBasket: 'Aggiungi Al Carrello',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Scegli il pacchetto e la quantità',
      continue: 'Continua',
      discount: 'Sconto',
      dueDateTextTwo: 'I pagamenti verranno suddivisi in due importi uguali che dovranno essere pagati alla firma e in data {date}',
      dueDateTextMultiple: 'I pagamenti verranno suddivisi in due importi uguali che dovranno essere pagati alla firma e in data {datesList}',
      error: 'Si è verificato un errore durante l\'invio dei dati',
      noAccommodations: 'Nessuna sistemazione',
      numberOfPeople: 'Numero di persone',
      package: 'Pacchetto',
      packageInCart: '{yourPackage} è nel carrello. Per modificare l\'ordine o per andare alla cassa,',
      packagePricing: 'Prezzo del pacchetto',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'N. di pacchetti',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Spese di commissione',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Scegli la quantità',
      readyToCall: '<span>Pronto a prenotare? Chiama subito al numero {phoneLink}</span> oppure compila il modulo se desideri conoscere i prezzi e le opzioni dei pacchetti.',
      requiredField: 'Campo obbligatorio',
      roomQty: 'N. di camere',
      roomType: 'Tipo di stanza',
      soldOut: 'Esaurito',
      subtotal: 'Totale parziale:',
      takenInCart: '(nel carrello)',
      total: 'Total:',
      yourTicket: 'Biglietto',
      viewCart: 'visualizza carrello»',
    }
  },
  ja() {
    return {
      accommodation: '宿泊施設',
      add: 'ADD',
      addToCart: 'カートに追加',
      addToBasket: 'カートに追加',
      buyNow: 'Buy Now',
      chooseYourPackage: 'パッケージと数量をご選択ください',
      continue: '続行',
      discount: 'ディスカウント',
      dueDateTextTwo: '支払いは、署名時と {date} の均等な分割になります',
      dueDateTextMultiple: '{datesList}の署名時に均等な分割のお支払いになります',
      error: '送信にエラーがありました。',
      noAccommodations: '宿泊なし',
      numberOfPeople: '# の人々',
      package: 'パッケージ',
      packageInCart: '{yourPackage}がカートにあります、編集または清算するには、',
      packagePricing: 'パッケージ価格',
      packagePricingSglmg: 'Your Package Pricing',
      packageTotal: 'Package Total',
      packageQty: 'パッケージ数量',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: '手数料',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: '数量を選択してください',
      readyToCall: '<span>予約するには、 {phoneLink} へ電話するか</span> 、価格とパッケージオプションのフォームにご記入ください。',
      requiredField: '入力必須項目です',
      roomQty: '部屋数',
      roomType: 'ルームタイプ',
      soldOut: '完売',
      subtotal: '小計',
      takenInCart: '(カートに入れました)',
      total: 'Total:',
      yourTicket: 'お客様のチケット',
      viewCart: 'カートを見る»',
    }
  },
  pl() {
    return {
      accommodation: 'noclegi',
      add: 'ADD',
      addToCart: 'DODAJ DO KOSZYKA',
      addToBasket: 'Add To Basket',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Choose Your Package & Quantity',
      continue: 'kontynuuj',
      discount: 'rabat',
      dueDateTextTwo: 'płatności zostaną podzielone na równe raty, należne w momencie zamówienia i {date}',
      dueDateTextMultiple: 'płatności zostaną podzielone na równe raty, należne w momencie zamówienia w poniższych terminach: {datesList}',
      error: 'wystąpił błąd w Twoim zgłoszeniu',
      noAccommodations: 'bez noclegów',
      numberOfPeople: 'liczba osób',
      package: 'pakiet',
      packageInCart: '{yourPackage} is in your cart. To edit or checkout,',
      packagePricing: 'cena pakietu',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'liczba pakietów',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Processing Fee',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Choose Your Quantity',
      readyToCall: '<span>Ready to Book? Call {phoneLink}</span> or complete the form for pricing and package options.',
      requiredField: 'This field is required',
      roomQty: 'liczba pokoi',
      roomType: 'rodzaj pokoju',
      soldOut: 'sprzedane',
      subtotal: 'suma:',
      takenInCart: '(Taken in Cart)',
      total: 'Total:',
      yourTicket: 'Your Ticket',
      viewCart: 'view your cart»',
    }
  },
  pt() {
    return {
      accommodation: 'Hospedagem',
      add: 'ADDICIONAR',
      addToCart: 'ADICIONAR AO CARRINHO',
      addToBasket: 'Adicionar à Cesta',
      buyNow: 'Buy Now',
      chooseYourPackage: 'Escolha Seu Pacote e Quantidade',
      continue: 'Continuar',
      discount: 'Desconto',
      dueDateTextTwo: 'Os pagamentos serão divididos igualmente e devidos na assinatura e em {date}',
      dueDateTextMultiple: 'Os pagamentos serão divididos igualmente e devidos na assinatura, em {datesList}',
      error: 'Houve um erro com sua submissão',
      noAccommodations: 'Sem Hospedagem',
      numberOfPeople: '# de Pessoas',
      package: 'Pacote',
      packageInCart: '{yourPackage} está no seu carrinho. Para editar ou finalizar a compra,',
      packagePricing: 'Preço do Pacote',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: 'Quantidade do Pacote',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: 'Taxa de Processamento',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: 'Escolha Sua Quantidade',
      readyToCall: '<span>Pronto para Reservar? Ligue para {phoneLink}</span> ou preencha o formulário para opções de preços e pacotes.',
      requiredField: 'Este campo é obrigatório',
      roomQty: 'Quantidade de Quartos',
      roomType: 'Tipo de Quarto',
      soldOut: 'Esgotado',
      subtotal: 'Subtotal:',
      total: 'Total:',
      takenInCart: '(Adicionado ao Carrinho)',
      yourTicket: 'Seu Bilhete',
      viewCart: 'ver seu carrinho»',
    }
  },
  zhCN() {
    return {
      accommodation: '住宿',
      add: '添加',
      addToCart: '添加至购物车',
      addToBasket: '加入购物车',
      buyNow: 'Buy Now',
      chooseYourPackage: '选择您的套票及数量',
      continue: '继续',
      discount: '折扣',
      dueDateTextTwo: '款项将平分，并在签署日及{date}到期',
      dueDateTextMultiple: '付款将按期支付，并在签署日{datesList}全部支付完毕',
      error: '提交时出错',
      noAccommodations: '无住宿',
      numberOfPeople: '人数',
      package: '套票',
      packageInCart: '{yourPackage}已在您的购物车中。如需编辑或结算，',
      packagePricing: '套票价格',
      packagePricingSglmg: 'Your Package Pricing',
      packageQty: '套票数量',
      packageTotal: 'Package Total',
      paymentCount: 'Or split the price into {count} payments of',
      processingFee: '处理费',
      processingFeeInfo:'This fee covers the cost of securely processing your payment and other administrative services required to complete your order.',
      chooseYourQuantity: '选择数量',
      readyToCall: '<span>请致电{phoneLink}</span>或填写表格以选择价格及套票类型。',
      requiredField: '必填项',
      roomQty: '房间数量',
      roomType: '房间类型',
      soldOut: '售罄',
      subtotal: '小计：',
      takenInCart: '（加入购物车）',
      total: 'Total:',
      yourTicket: '您的门票',
      viewCart: '查看您的购物车»',
    }
  },
}
